export default function SalesFilled({ className }) {
    return (
      <svg className={className} width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M10.7267 3.60063C10.2568 3.50525 9.77042 3.45518 9.27236 3.45518C5.25595 3.45518 2 6.71113 2 10.7275C2 14.744 5.25595 17.9999 9.27236 17.9999C13.2888 17.9999 16.5447 14.744 16.5447 10.7275C16.5447 10.2957 16.5071 9.87256 16.4349 9.46136"
              stroke="currentColor"
              strokeWidth="1.4" />
        <path d="M17.981 8.77227C17.7353 5.15436 14.8436 2.26264 11.2257 2.01693C10.9502 1.99821 10.7256 2.22386 10.7256 2.5V8.27236C10.7256 8.82464 11.1733 9.27236 11.7256 9.27236H17.4979C17.7741 9.27236 17.9997 9.04777 17.981 8.77227Z"
              fill="currentColor"
              stroke="currentColor"
              strokeWidth="1.4" />
      </svg>
    )
}
